import { useState } from 'react';

const WebdesignPricing = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Was kostet eine professionelle Website?',
      answer: 'Die Kosten variieren je nach Anforderungen. Eine einfache Unternehmenswebsite startet bei ca. 2.500€, während umfangreichere Projekte mit Online-Shop oder individuellen Funktionen zwischen 5.000€ und 15.000€ liegen können.'
    },
    {
      question: 'Kann ich meine Website selbst pflegen?',
      answer: 'Ja, wir entwickeln Ihre Website mit einem benutzerfreundlichen Content Management System (CMS), sodass Sie Inhalte, Bilder und Texte selbst aktualisieren können. Wir schulen Sie gerne im Umgang damit.'
    },
    {
      question: 'Ist die Website für Suchmaschinen optimiert?',
      answer: 'Ja, alle unsere Websites werden nach aktuellen SEO-Standards entwickelt. Das umfasst technische Optimierung, schnelle Ladezeiten, mobile Optimierung und sauberen Code für bessere Google-Rankings.'
    },
    {
      question: 'Bieten Sie auch Wartung und Support an?',
      answer: 'Ja, wir bieten verschiedene Wartungspakete an, die regelmäßige Updates, Backups, Sicherheits-Monitoring und technischen Support umfassen. So bleibt Ihre Website immer aktuell und sicher.'
    },
    {
      question: 'Kann ich meine bestehende Website modernisieren?',
      answer: 'Absolut! Wir analysieren Ihre bestehende Website und entwickeln ein Konzept für eine moderne, performante Neugestaltung. Dabei können wir bestehende Inhalte übernehmen und das Design komplett erneuern.'
    }
  ];

  return (
    <section className="py-32 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full"></div>
            <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-light">FAQ</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
            Häufig gestellte<br />Fragen
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto font-light">
            Antworten auf die wichtigsten Fragen rund um Webdesign und Entwicklung
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-zinc-900 border transition-all duration-300 ${
                openFAQ === index ? 'border-[#d1bc8a]' : 'border-zinc-800'
              }`}
            >
              <button
                onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                className="w-full p-8 flex items-center justify-between text-left cursor-pointer group"
              >
                <h3 className={`text-xl font-medium transition-colors duration-300 pr-8 ${
                  openFAQ === index ? 'text-[#d1bc8a]' : 'text-white group-hover:text-[#d1bc8a]'
                }`}>
                  {faq.question}
                </h3>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-2xl transition-colors duration-300 flex-shrink-0 ${
                  openFAQ === index ? 'text-[#d1bc8a]' : 'text-gray-500 group-hover:text-[#d1bc8a]'
                }`}></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openFAQ === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-8">
                  <div className="w-12 h-px bg-[#d1bc8a] mb-6"></div>
                  <p className="text-gray-400 leading-relaxed font-light">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WebdesignPricing;